import ApiService from "service/Api";
import TokenService from "service/Token";
import { getData, removeData, storeData } from "utilities/helper";
import { AuthPayloadTypes } from "utilities/types/Auth";

const AuthService = {
  Login: async (payload: AuthPayloadTypes) => {
    const { email, password } = payload;
    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      data: {
        email,
        password,
      },
      url: "/auth/login",
    };
    try {
      const res = await ApiService.apiRequest(requestData);
      const data = res.data.data;

      if (
        data.user.role === "superadmin" ||
        data.user.role === "admin" ||
        data.user.role === "tenant" ||
        data.user.role === "partner"
      ) {
        TokenService.saveIsAuthenticated(true);
        // TokenService.saveRefreshToken(data.tokens.refresh_token);

        const userData = {
          userId: data.user.id,
          email: data.user.email,
          name: data.user.name,
          phoneNumber: data.user.phone_number,
          role: data.user.role,
          tenant: data.user.tenant,
        };
        AuthService.saveDataAuth(JSON.stringify(userData));
        window.location.reload();
      } else {
        throw new Error("Role permission access denied");
      }
    } catch (error) {
      throw error;
    }
  },

  saveDataAuth(resData: string) {
    storeData("auth_data", resData);
  },

  getDataAuth() {
    return JSON.parse(getData("auth_data") ?? "");
  },

  removeDataAuth() {
    removeData("auth_data");
  },

  Logout: async () => {
    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      url: "/auth/logout",
    };
    try {
      await ApiService.apiRequest(requestData);
      TokenService.removeToken();
      TokenService.removeRefreshToken();
      TokenService.removeIsAuthenticated();
      AuthService.removeDataAuth();
      window.location.reload();
    } catch (error) {
      TokenService.removeToken();
      TokenService.removeRefreshToken();
      TokenService.removeIsAuthenticated();
      AuthService.removeDataAuth();
      window.location.reload();
      throw error;
    }
  },

  RefreshToken: async () => {
    const requestData = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      url: "/auth/refresh-token",
    };
    try {
      const response = await ApiService.apiRequest(requestData);
      window.location.reload();
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  RemoveTokenAuthentication: () => {
    TokenService.removeToken();
    TokenService.removeRefreshToken();
    TokenService.removeIsAuthenticated();
    AuthService.removeDataAuth();
    window.location.reload();
  },
};

export default AuthService;
